import { MutationTree } from 'vuex';
import { ServiceProvidersState } from './types';

export const mutations: MutationTree<ServiceProvidersState> = {
  pushServiceProviders:(state, data) => {
    state.service_providers = state.service_providers.concat(data)
  },
  setServiceProviders:(state, data) => {
    state.service_providers = data
  },
  setServiceProviderItem:(state, data) => {
    state.serviceProviderItem = data
  },
};
